
const digest = 'c52f072a7dc5424e2e10a88791701726ba0aaa622ce87e5e5e70ffef6466a314';
const classes = {"wrapper":"_wrapper_1oc34_1","header":"_header_1oc34_9","remove":"_remove_1oc34_17","item":"_item_1oc34_28","label":"_label_1oc34_37","value":"_value_1oc34_50"};
const css = `._wrapper_1oc34_1 {
  display: flex;
  background-color: #ffffff;
  border-radius: 15px;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}
._wrapper_1oc34_1 ._header_1oc34_9 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px #f0f7fe solid;
  padding: 20px 30px;
}
._wrapper_1oc34_1 ._header_1oc34_9 ._remove_1oc34_17 {
  border: 1px solid #f4f3fd;
  border-radius: 100%;
  padding: 7px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
._wrapper_1oc34_1 ._header_1oc34_9 ._remove_1oc34_17 img {
  width: 100%;
}
._wrapper_1oc34_1 ._item_1oc34_28 {
  padding: 10px 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #3c3f9c;
  background-color: #ffffff;
}
._wrapper_1oc34_1 ._item_1oc34_28 ._label_1oc34_37 {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
._wrapper_1oc34_1 ._item_1oc34_28:nth-child(even) {
  background-color: rgba(240, 247, 254, 0.7019607843);
}
._wrapper_1oc34_1 ._item_1oc34_28:last-child {
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
._wrapper_1oc34_1 ._item_1oc34_28 ._value_1oc34_50 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  